import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/ui/panel";

export function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon,
}: {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
}) {
  return (
    <Panel className="px-8 py-12 text-center">
      {icon ? (
        <div className="mb-4 flex justify-center text-rs-ink-subtle">
          {icon}
        </div>
      ) : null}
      <h3 className="text-lg font-semibold text-rs-ink">{title}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm text-rs-ink-muted">
        {description}
      </p>
      {actionLabel && onAction ? (
        <Button className="mt-6" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Panel>
  );
}
